/**
 * Language Switcher VI ↔ EN — dùng cho TopBar public pages.
 *
 * Persist qua localStorage (key `i18nextLng` — config trong src/i18n/index.ts).
 * Compact pill style, KHÔNG dùng Menu — chỉ 2 ngôn ngữ nên toggle button hợp lý hơn.
 */
import { useTranslation } from 'react-i18next'
import { Box, ButtonBase, Stack, Typography } from '@mui/material'
import { brand } from '../theme/brand'

const LANGS: { code: 'vi' | 'en'; label: string }[] = [
  { code: 'vi', label: 'VI' },
  { code: 'en', label: 'EN' },
]

interface Props {
  /** Đặt true khi TopBar đang trong chế độ hero/dark (transparent over hero). */
  dark?: boolean
}

export default function LanguageSwitcher({ dark = false }: Props) {
  const { i18n } = useTranslation()
  const current = (i18n.resolvedLanguage || i18n.language || 'vi').slice(0, 2)

  const trackBg = dark ? 'rgba(255,255,255,0.14)' : 'rgba(20,78,140,0.08)'
  const trackBorder = dark ? 'rgba(255,255,255,0.22)' : 'rgba(20,78,140,0.18)'
  const inactiveColor = dark ? 'rgba(255,255,255,0.78)' : '#5E6B7E'

  return (
    <Box
      sx={{
        display: 'inline-flex',
        background: trackBg,
        border: `1px solid ${trackBorder}`,
        borderRadius: 999,
        p: 0.4,
      }}
    >
      <Stack direction="row" spacing={0.3}>
        {LANGS.map((lang) => {
          const active = current === lang.code
          return (
            <ButtonBase
              key={lang.code}
              onClick={() => {
                if (!active) i18n.changeLanguage(lang.code)
              }}
              sx={{
                px: 1.4,
                py: 0.4,
                borderRadius: 999,
                background: active ? brand.hotPink : 'transparent',
                color: active ? 'common.white' : inactiveColor,
                transition: 'all 0.15s ease',
                '&:hover': {
                  background: active ? brand.hotPink : (dark ? 'rgba(255,255,255,0.08)' : 'rgba(20,78,140,0.05)'),
                },
              }}
              aria-pressed={active}
              aria-label={`Switch to ${lang.label}`}
            >
              <Typography
                sx={{
                  fontSize: '0.72rem',
                  fontWeight: 800,
                  letterSpacing: 1,
                  lineHeight: 1,
                  fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
                }}
              >
                {lang.label}
              </Typography>
            </ButtonBase>
          )
        })}
      </Stack>
    </Box>
  )
}
